export default __webpack_public_path__ + "static/media/SKALA-Logo-Reversed-YELLOW (4).ba17576d.pdf";